import type { BrandingDb } from '@domain/schemas/branding.schema';

export const normaliseBranding = <T = BrandingDb>(branding: T & { sk: string; pk: string }): T => ({
  ...branding,
  id: branding.sk,
});
